import { useEffect, useState } from "react";
import { getFileMedia, isLocalFile } from "./fileMedia";

export default function useFileSource(file) {
  const [source, setSource] = useState(null);
  useEffect(() => {
    if (!isLocalFile(file)) return undefined;
    const url = URL.createObjectURL(file);
    setSource({ file, url });
    return () => URL.revokeObjectURL(url);
  }, [file]);
  const media = getFileMedia(file);
  return {
    ...media,
    url: isLocalFile(file)
      ? source?.file === file
        ? source.url
        : ""
      : media.url,
  };
}
